/**
 * Browser download helpers for blob responses (CSV / XLSX exports).
 */

export function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'report';
}

/**
 * Parse the filename out of a Content-Disposition header.
 * Handles `filename*=UTF-8''...` and `filename="..."`; returns null when absent.
 */
export function filenameFromDisposition(header) {
  if (!header) return null;
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return star[1].trim();
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : null;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Download an axios blob response, naming the file from the server header when present.
 */
export function downloadResponse(response, fallbackName) {
  const headers = response?.headers || {};
  const disposition = headers['content-disposition'] || headers['Content-Disposition'];
  const name = filenameFromDisposition(disposition) || fallbackName;
  downloadBlob(response.data, name);
  return name;
}
